<template>
  <div>
    <div class="mt-2 p-4">
      <div class="content condition-content-container">
        <h1
          v-if="title != ''"
          class="title is-4"
        >
          {{ title }}
        </h1>
        <h2 class="title is-5 underline">
          1. Exclusivité
        </h2>
        <p>
          Lorsqu’un logement est inscrit sur notre plateforme avec l’un des statuts suivants : <strong> « À louer » </strong>, <strong> « En rénovation » </strong> ou <strong>« En attente » </strong>, Devloc Immobilier Inc. bénéficie d’un droit exclusif pour la gestion locative de ce logement. Cela implique qu’aucune autre société ou tiers ne peut être mandaté simultanément pour la location du même bien immobilier.
        </p>
        <h3 class="title is-6">
          1.1 Situations particulières
        </h3>
        <ul>
          <li>
            <strong>1.1.1 Logement occupé</strong>
            Si le mandat a été enregistré avec le statut <strong> « À louer »</strong> et que, par la suite, le locataire occupant vous informe de son intention de finalement vouloir <strong>renouveler</strong> son bail, voici <strong>les étapes qui doivent être effectuées</strong>
            <ul>
              <li>
                Informer Devloc de la situation par courriel à l’adresse <a href="mailto:info@devloc.ca">info@devloc.ca</a> afin de valider si le logement est <strong> actuellement en application ou non </strong>ainsi que pour recevoir une <strong> estimation des frais d’annulation à ce jour.</strong>
                <ul>
                  <li>
                    Si le logement <strong> n’est pas en cours d’application</strong>, nous répondrons à votre courriel en vous mentionnant <strong> les frais d'annulation.</strong>  La poursuite du processus de location sera maintenue jusqu’à réception d’une confirmation écrite officielle de votre part pour annuler le mandat.
                    <ul>
                      <li>
                        Notez que des frais supplémentaires peuvent s’appliquer si des tâches additionnelles sont effectuées en lien avec le mandat de location avant la réception de l’annulation écrite formelle.
                      </li>
                      <li>
                        Nous vous recommandons de refiler la facture au locataire en lui expliquant qu’il devra payer les frais d'annulation s’il souhaite renouveler son bail, et ce, en plus d’accepter le nouveau prix du loyer au renouvellement.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Si le logement <strong>est en cours d’application</strong>, nous répondrons à votre courriel vous informant des avancements du processus d’application en cours. Si l'application n'aboutit pas finalement, nous vous en informerons par courriel et, si le locataire occupant veut toujours renouveler son bail, nous pourrons passer par les étapes mentionnées ci-haut.
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <strong>1.1.2 Logement vacant: </strong> Si le mandat est enregistré avec le statut <strong>« À louer »</strong> ou <strong>« En rénovation »</strong>, mais, après un certain temps, vous décidez <strong>d'annuler le mandat de location </strong>(exemple: relocalisation d’un de vos locataires, changement de plan, etc.) <strong>les étapes suivantes doivent être respectées:</strong>
            <ul>
              <li>
                Informer Devloc de la situation par courriel à l’adresse <a href="mailto:info@devloc.ca">info@devloc.ca</a> afin de valider si le logement est <strong>actuellement en application ou non </strong>ainsi que pour recevoir une <strong>estimation des frais d’annulation à ce jour.</strong>
                <ul>
                  <li>
                    Si le logement <strong>n’est pas en cours d’application</strong>, nous répondrons à votre courriel en vous mentionnant les <strong>frais d'annulation</strong> et nous changerons le statut du logement sur la plateforme vers «<strong>loué</strong>»
                  </li>
                  <li>
                    Si le logement <strong>est en cours d’application</strong>, nous répondrons à votre courriel et nous analyserons la situation ensemble en priorisant vos besoins.
                  </li>
                  <li>
                    Dans tous les cas, les <strong>frais d’annulation</strong> varient entre <strong>0$</strong> et la <strong>totalité</strong> d’une location, et ce, en fonction du travail effectué par notre équipe au moment de l'annulation officielle.
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>

        <h2 class="title is-5 underline">
          2. Délais de réponse aux applications
        </h2>
        <p>
          Pour garantir une gestion locative efficace et optimale, vous disposez d’un délai maximal de <strong>24 heures ouvrables</strong> pour <strong>confirmer</strong> ou <strong>refuser</strong> une application envoyée par courriel de Devloc. Passé ce délai, toute application sera considérée comme <strong>acceptée</strong>. Cette mesure vise à minimiser les risques de perte de candidats dans un marché concurrentiel.
        </p>

        <h2 class="title is-5 underline">
          3. Déplacements inutiles
        </h2>
        <ul>
          <li>
            <strong>3.1 Accès au logement vacant :</strong> Tout logement enregistré avec le statut <strong>« À louer »</strong> doit être <strong>accessible en tout temps</strong> selon les modalités précisées dans la section <strong>« Accès clé »</strong> de la plateforme. En cas <strong>d’inaccessibilité</strong>, des frais de déplacement de <strong>75</strong> à <strong>150 $</strong> seront appliqués.
          </li>
          <li>
            <strong>3.2 Prise de photos d’un logement vacant</strong> Tout logement enregistré avec le statut <strong>« À louer »</strong> sur la plateforme doit être prêt et propre pour les prises de photos. Si le logement n’est pas dans un état jugé <strong>adéquat et optimal</strong> par notre équipe pour la prise de photos, des frais de déplacement de <strong>75</strong> à <strong>150 $</strong> seront facturés.
          </li>
          <li>
            <strong>3.3 Logement occupé non-propre :</strong> Lorsqu’un logement est <strong>occupé</strong> par un locataire et qu’il est enregistré avec le statut <strong>«À louer»</strong>, il relève de votre responsabilité de vous assurer que le logement soit dans une <strong>bonne condition esthétique</strong> pour être reloué et pris en photos. Bien que nous comprenions qu’il ne soit pas toujours possible d’effectuer un <strong>état des lieux</strong> de tous vos logements occupés qui sont à relouer, nous vous demandons d’être vigilant et de cibler les logements pour lesquels vous pensez qu’un état des lieux serait nécessaire avant de le mettre «À louer» sur la plateforme. Si, pour quelconques raisons, le logement <strong>occupé</strong> est jugé <strong>insalubre</strong> ou <strong>non-conforme</strong> pour être visité ou pris en photos par notre équipe, des frais de déplacements de <strong>75</strong> à <strong>150$</strong> seront facturés. Dans l’éventualité de cette situation, un membre de notre équipe vous enverra un courriel avec des photos à l’appui détaillant la situation.
          </li>
        </ul>

        <h2 class="title is-5 underline">
          4. Confidentialité et partage des documents
        </h2>
        <p>
          Tous les documents partagés entre Devloc Immobilier Inc. et ses clients sont strictement confidentiels. Toute diffusion ou partage sans autorisation est formellement interdite.
        </p>

        <h2 class="title is-5 underline">
          5. Modifications des documents à signer
        </h2>
        <p>
          <strong>Une seule</strong> modification <strong>annuelle</strong> sans frais est incluse pour l'ensemble de vos documents à signer (bail, annexes, règlements, etc.). Toute modification supplémentaire dans la même année sera facturée à raison de<strong> 75 $/heure</strong>. Si vous avez plusieurs modifications à effectuer sur différents documents, nous vous encourageons donc à nous les envoyer simultanément afin que nous puissions faire toutes les modifications requises une seule fois par année.
        </p>

        <h2 class="title is-5 underline">
          6. Clause de limitation de responsabilité
        </h2>
        <p>
          Devloc Immobilier Inc. agit exclusivement à titre d'intermédiaire dans le processus de location entre le locataire et le propriétaire. Une fois le bail signé entre les parties, Devloc Immobilier Inc. n'assume aucune responsabilité relative:
        </p>
        <ol>
          <li>aux conditions ou à l’état des lieux loués,</li>
          <li>à l’exécution des obligations des parties au bail,</li>
          <li>aux différends pouvant survenir entre le locataire et le propriétaire.</li>
        </ol>
        <p>
          <strong>Devloc Immobilier Inc. ne pourra en aucun cas être tenue responsable des dommages, pertes ou litiges découlant de la relation contractuelle entre le locataire et le propriétaire</strong>
        </p>

        <h2 class="title is-5 underline">
          7. Acceptation des conditions
        </h2>
        <p>
          En utilisant nos services et en cliquant sur «<strong>J’ai bien lu et compris les conditions mentionnées ci-dessus et je les accepte</strong> », vous acceptez ces termes et conditions dans leur intégralité.
        </p>
      </div>
    </div>
    <div class="mt-2 p-4">
      <slot name="form" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
<style scoped>
  .condition-content-container a {
    color: blue;
    font-weight: bold;
  }
  .condition-content-container p, .condition-content-container li {
    font-size: 16px;
    line-height: 25px;
  }
  .condition-content-container .underline {
    text-decoration: underline;
  }
</style>
